import { useMemo, useCallback, FC } from 'react'
import SlideInMotion, { SlideInDirection } from './SlideInMotion'
// import { FaPlus, FaMinus } from 'react-icons/fa'
// import {
//   useAppSelector,
//   useAppDispatch,
// } from '../app/hooks'
import useMediaQuery from '../hooks/useMediaQuery'
// import {
//   addOneToCart,
//   removeOneFromCart,
// } from '../features/cart/cartSlice'
import { baseTheme } from '../styles/theme'
import * as layout from '../styles/Layout.styled'
import * as portfolio from '../styles/Portfolio.styled'
import { getProductInfo } from '../utilities/products'
import { Section, Product } from '../typing/enums'
import { MyRequireContext, Pics } from '../typing/types'
// import { ProductInfo } from '../typing/interfaces'

export const Portfolio: FC = () => {
  // const dispatch = useAppDispatch()

  // const itemsInCart = useAppSelector(state => state.cart.itemsInCart)

  const pics = useMemo<Pics>(() => {
    // https://webpack.js.org/guides/dependency-management/
    // https://b-heesakkers.medium.com/how-to-resolve-typeerror-require-context-is-not-a-function-in-jest-7f67e6d0990f
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18446

    // dynamically load files from dir (top level only)
    const importAll = (r: MyRequireContext) => {
      const cache = r.keys().reduce((accumulator: Pics, key: string) => {
        accumulator[key] = r(key)
        return accumulator
      }, {})

      return cache
    }

    const pics = importAll(require.context('../assets/pics/', false, /\.jpg$/))

    return pics
  }, [])

  const findProduct = useCallback(({
    name,
  }: {
    name: string,
  }) => {
    const escapeRegExp = (str: string) => str
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')  // escape special characters

    const myProduct = Object.values(Product).find(product => {
      // matches the product surrounded by word boundaries or edges
      const reProduct = new RegExp(
        `(^|[^a-zA-Z0-9])${escapeRegExp(product)}([^a-zA-Z0-9]|$)`, 'i'
      )

      return reProduct.test(name)
    })

    return myProduct
  }, [])

  const formatPicName = useCallback((str:string) => {
    return str
      .replace(/_/g, ' ')
      .replace(/^\.\//, '')
      .replace(/\.jpg$/, '')
  }, [])

  const isSmallScreen = useMediaQuery(`(max-width: ${baseTheme.screen.small})`)

  // TODO sold
  // https://ant.design/components/watermark

  // const Quantity: FC<{
  //   productInfo: ProductInfo,
  // }> = ({
  //   productInfo,
  // }) => {
  //   const { id } = productInfo

  //   return (
  //     <div>
  //       <span>Add Item (</span>
  //       <portfolio.StyledQuantity>
  //         {`${itemsInCart.find(item => item.id === id)?.quantity || 0}`}
  //       </portfolio.StyledQuantity>
  //       <span>)</span>
  //     </div>
  //   )
  // }

  return (
    <>
      <SlideInMotion direction={SlideInDirection.left} delay={0.4}>
        <layout.StyledSectionName>{Section.portfolio}</layout.StyledSectionName>
      </SlideInMotion>
      <SlideInMotion direction={SlideInDirection.left} delay={0.6}>
        {
          (!isSmallScreen) &&
            <layout.StyledSectionText $textAlign={'center'}>
              <i>Click any image to zoom.</i>
            </layout.StyledSectionText>
        }
      </SlideInMotion>
      <portfolio.StyledPicContainer>
        {Object.entries(pics).map(([name, pic], index) => {
          const product = findProduct({ name })
          const productInfo = product && getProductInfo({ product })

          const direction = (index % 2 === 0)
            ? SlideInDirection.left
            : SlideInDirection.right

          return (
            <>
              {
                productInfo &&
                  <portfolio.StyledPicItem key={index}>
                    <SlideInMotion
                      key={index}
                      direction={direction}
                      delay={1}
                    >
                      <portfolio.StyledPicName>{formatPicName(name)}</portfolio.StyledPicName>
                      <portfolio.StyledPicImg
                        src={pic}
                        alt={name}
                        whileTap={
                          !isSmallScreen
                            ? { scale: 2.0 }
                            : undefined
                        }
                        $side={direction}
                      />
                      {/* <portfolio.StyledControlsContainer>
                        <Quantity productInfo={productInfo}/>
                        <portfolio.StyledButton
                          whileTap={{ scale: 0.9 }}
                          onClick={() => (
                            dispatch(addOneToCart(productInfo.id))
                          )}
                        >
                          <FaPlus color={theme.colors.palette.secondary}/>
                        </portfolio.StyledButton>
                        <portfolio.StyledButton
                          whileTap={{ scale: 0.9 }}
                          onClick={() => (
                            dispatch(removeOneFromCart(productInfo.id))
                          )}
                        >
                          <FaMinus color={theme.colors.palette.secondary}/>
                        </portfolio.StyledButton>
                      </portfolio.StyledControlsContainer> */}
                    </SlideInMotion>
                  </portfolio.StyledPicItem>
              }
            </>
          )
        })}
      </portfolio.StyledPicContainer>
    </>
  )
}
